import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import * as _ from 'lodash';
import { CompanyStateService } from 'src/app/auth/services/company-state.service';
import { ModalService } from '../../modals/modal.service';
import { DistributionModalComponent } from '../distribution-modal/distribution-modal.component';

@Component({
  selector: 'distribution-selector',
  templateUrl: './distribution-selector.component.html',
  styleUrls: ['./distribution-selector.component.scss'],
  standalone: false,
})
export class DistributionSelectorComponent implements OnInit, OnChanges {
  @Input() distribution: any;
  @Output() distributionChange: EventEmitter<any> = new EventEmitter<any>();
  @Input() subcompanyDistribution: any;
  @Output() subcompanyDistributionChange: EventEmitter<any> =
    new EventEmitter<any>();
  @Input() distributeToSubcompanies: boolean;
  @Output() distributeToSubcompaniesChange: EventEmitter<boolean> =
    new EventEmitter<boolean>();
  @Input() enableSubcompanies: boolean = false;
  @Input() distributeToAll?: boolean = true;
  @Output() distributeToAllChange: EventEmitter<boolean> =
    new EventEmitter<boolean>();
  @Input() subcompanyDistributeToAll?: boolean = false;
  @Output() subcompanyDistributeToAllChange: EventEmitter<boolean> =
    new EventEmitter<boolean>();
  @Input() enableSubcompanyDistributeToAll?: boolean = false;
  @Input() enableFeatureCheck: boolean = true;
  @Input() hideCta?: boolean;
  @Input() readonly?: boolean;
  @Input() showLabel: boolean = false;
  @Input() inputId: string;

  get distributionSelectionMessage(): string {
    let message = 'No Displays Selected';

    let count = this.distribution ? this.distribution.length : 0;
    if (this.distributeToSubcompanies) {
      count += this.subcompanyDistribution
        ? this.subcompanyDistribution.length
        : 0;
    }

    if (count > 0) {
      if (count === 1) {
        message = '1 Display Selected';
      } else {
        message = count + ' Displays Selected';
      }
    }
    return message;
  }

  get subcompanyDistributeToAllAvailable(): boolean {
    return (
      this.enableSubcompanyDistributeToAll &&
      this.distributeToAll &&
      !this.companyStateService.isRootCompanySelected()
    );
  }

  constructor(
    private modalService: ModalService,
    private changeDetectorRef: ChangeDetectorRef,
    private companyStateService: CompanyStateService,
  ) {}

  ngOnInit(): void {
    if (this.companyStateService.isRootCompanySelected()) {
      this.subcompanyDistributeToAll = false;
      this.distributeToSubcompanies = false;
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (
      changes.distributeToAll &&
      changes.distributeToAll.currentValue === undefined
    ) {
      this.distributeToAll = true;
    }
  }

  manage() {
    if (this.readonly) {
      return;
    }
    this.modalService
      .showLargeDialog(
        DistributionModalComponent,
        {
          distribution: this.distribution ? _.cloneDeep(this.distribution) : [],
          subcompanyDistribution: this.subcompanyDistribution
            ? _.cloneDeep(this.subcompanyDistribution)
            : [],
          distributeToSubcompanies: this.distributeToSubcompanies,
          enableSubcompanies: this.enableSubcompanies,
          enableFeatureCheck: this.enableFeatureCheck,
        },
        null,
        'distributionField' + this.inputId,
      )
      .then((distribution: any) => {
        this.distribution = distribution.distribution;
        this.subcompanyDistribution = distribution.subcompanyDistribution;
        this.distributeToSubcompanies = distribution.distributeToSubcompanies;
        this.distributionChange.emit(distribution.distribution);
        this.subcompanyDistributionChange.emit(
          distribution.subcompanyDistribution,
        );
        this.distributeToSubcompaniesChange.emit(
          distribution.distributeToSubcompanies,
        );
        this.changeDetectorRef.detectChanges();
      })
      .catch(() => {});
  }

  outputDistributeToAll() {
    this.distributeToSubcompanies = false;
    this.distributeToSubcompaniesChange.emit(false);

    this.subcompanyDistributeToAll = false;
    this.subcompanyDistributeToAllChange.emit(false);

    this.distributeToAllChange.emit(this.distributeToAll);
    this.changeDetectorRef.detectChanges();
  }

  outputSubcompanyDistributeToAll() {
    this.distributeToSubcompanies = this.subcompanyDistributeToAll;
    this.distributeToSubcompaniesChange.emit(this.subcompanyDistributeToAll);

    this.subcompanyDistributeToAllChange.emit(this.subcompanyDistributeToAll);
    this.changeDetectorRef.detectChanges();
  }
}
